import { onAuthStateChanged, signOut } from "firebase/auth";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Logo.jpeg";
import { Link } from "react-router-dom";
import { db } from "../../firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth } from "../../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword
} from "firebase/auth";
import "./Navbar.css"
const Navbar = ({ cartCount, showModal, setShowModal, redirectAfterLogin, setRedirectAfterLogin }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isSignup, setIsSignup] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const handleSignup = async () => {
    if (!name || !mobile || !password) {
      alert("Please fill all fields");
      return;
    }
    if (mobile.length !== 10) {
      alert("Enter valid mobile number");
      return;
    }
    try {
      const fakeEmail = mobile + "@quickseva.com";

      const userCredential =
        await createUserWithEmailAndPassword(
          auth,
          fakeEmail,
          password
        );

      const user = userCredential.user;

      // 🔥 Store user data in Firestore
      await setDoc(doc(db, "users", user.uid), {
        name: name,
        mobile: mobile,
        createdAt: new Date()
      });

      alert("Account Created Successfully ✅");
      setShowModal(false);
      navigate("/customer");

    } catch (error) {
      alert(error.message);
    }
  };
  const handleLogin = async () => {
    if (!mobile || !password) {
      alert("Enter mobile and password");
      return;
    }

    try {
      const fakeEmail = mobile + "@quickseva.com";

      const userCredential =
        await signInWithEmailAndPassword(
          auth,
          fakeEmail,
          password
        );

      const user = userCredential.user;
      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (userDoc.exists()) {
        console.log("User Data:", userDoc.data());
      }

      alert("Login Successful ✅");
      setShowModal(false);
      if (redirectAfterLogin) {
        navigate("/customer");
      }

    } catch (error) {
      alert("Invalid Mobile or Password ❌");
    }
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);

        const docRef = doc(db, "users", currentUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setUserData(docSnap.data());
        }
      } else {
        setUser(null);
        setUserData(null);
      }
    });

    return () => unsubscribe();
  }, []);
  const handleLogout = async () => {
    await signOut(auth);
    alert("Logged out successfully");
    setShowModal(false);
    navigate("/");
  };
  return (
    <nav className="navbar navbar-expand-lg fixed-top custom-navbar">
      <div className="container-fluid px-4">

        <a className="navbar-brand" href="/">
          <img
            src={logo}
            alt="QuickSeva Logo"
            className="img-fluid navbar-logo"
          />
        </a>

        <div className="d-flex align-items-center gap-2 mobile-icons">

          {/* Cart */}
          <button
            className="btn cart-btn position-relative d-lg-none"
            data-bs-toggle="offcanvas"
            data-bs-target="#cartOffcanvas"
          >
            🛒
            {cartCount > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {cartCount}
              </span>
            )}
          </button>

          <a href="tel:+917661045308" className="btn call-btn-2">
            <i className="bi bi-telephone-fill me-2 call-icon"></i> Call Now
          </a>

          {/* Navbar Toggle */}
          <button
            className="navbar-toggler border-0"
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={menuOpen ? "bi bi-x-lg" : "bi bi-list"}></i>
          </button>

        </div>

        <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}>

          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 text-center">

            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>About Us</Link>
            </li>

            <li
              className="nav-item dropdown"
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <a
                className="nav-link dropdown-toggle"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setDropdownOpen(!dropdownOpen);
                }}
              >
                Services
              </a>

              <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                <li><Link className="dropdown-item" to="/laundry" onClick={() => setMenuOpen(false)}>Laundry</Link></li>
                <li><Link className="dropdown-item" to="/electrician" onClick={() => setMenuOpen(false)}>Electrician</Link></li>
                <li><Link className="dropdown-item" to="/plumber" onClick={() => setMenuOpen(false)}>Plumber</Link></li>
                <li><Link className="dropdown-item" to="/acmachine" onClick={() => setMenuOpen(false)}>AC Services</Link></li>
                <li><Link className="dropdown-item" to="/washing" onClick={() => setMenuOpen(false)}>Washing Machine</Link></li>
                <li><Link className="dropdown-item" to="/fridge" onClick={() => setMenuOpen(false)}>Fridge Repair</Link></li>
                <li><Link className="dropdown-item" to="/carpenter" onClick={() => setMenuOpen(false)}>Carpenter</Link></li>
                <li><Link className="dropdown-item" to="/cctv" onClick={() => setMenuOpen(false)}>CCTV technician</Link></li>
                <li><Link className="dropdown-item" to="/cooler" onClick={() => setMenuOpen(false)}>Cooler Technician</Link></li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>Why Choose Us</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>FAQs</Link>
            </li>
            {user && (
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/customer"
                  onClick={() => setMenuOpen(false)}
                >
                  My Bookings
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>Contact</Link>
            </li>

          </ul>

          <div className="d-flex align-items-center gap-3 right-section">

            {/* Desktop Cart */}
            <button
              className="btn position-relative"
              data-bs-toggle="offcanvas"
              data-bs-target="#cartOffcanvas"
            >
              🛒
              {cartCount > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {cartCount}
                </span>
              )}
            </button>

            <a href="tel:+917661045308" className="btn call-btn">
              <i className="bi bi-telephone-fill me-2 call-icon"></i> Call Now
            </a>

            {/* Login Button */}
            <button
              onClick={() => {
                setRedirectAfterLogin(true); // redirect when login from navbar
                setShowModal(true);
                setMenuOpen(false);
              }}
              className="nav-link"
            >
              Login
            </button>

          </div>

        </div>
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">

            {!user ? (
              <>
                <h4 className="mb-3 text-center">
                  {isSignup ? "Signup" : "Login"}
                </h4>

                {isSignup && (
                  <input
                    type="text"
                    placeholder="Full Name"
                    className="form-control mb-2"
                    onChange={(e) => setName(e.target.value)}
                  />
                )}

                <input
                  type="text"
                  placeholder="Mobile Number"
                  className="form-control mb-2"
                  onChange={(e) => setMobile(e.target.value)}
                />

                <input
                  type="password"
                  placeholder="Password"
                  className="form-control mb-3"
                  onChange={(e) => setPassword(e.target.value)}
                />

                <button
                  className="btn btn-success w-100"
                  onClick={isSignup ? handleSignup : handleLogin}
                >
                  {isSignup ? "Create Account" : "Login"}
                </button>

                <p
                  className="mt-3 text-center text-primary"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsSignup(!isSignup)}
                >
                  {isSignup
                    ? "Already have an account? Login"
                    : "New user? Signup"}
                </p>
              </>
            ) : (
              <>
                <h4 className="text-center mb-3">Account Details</h4>

                <p><strong>Name:</strong> {userData?.name}</p>
                <p><strong>Mobile:</strong> {userData?.mobile}</p>

                <button
                  className="btn btn-danger w-100 mt-3"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </>
            )}

            <button
              className="btn btn-outline-danger w-100 mt-3"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>

          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
